import { NewWindowAnchor } from '@xo-union/component-standard-elements';
import Icon from '@xo-union/tk-component-icons';
import { IconName } from '@xo-union/dist-iconography';
import React from 'react';

import styles from './action.scss';

interface Props {
  iconName?: IconName;
  children: any;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  rel?: string;
}

export const Action: React.FC<Props> = ({ iconName, children, onClick, rel, className = '', ...rest }) => (
  <NewWindowAnchor className={`${className} ${styles.container}`} tabIndex="0" onClick={onClick} rel={rel} {...rest}>
    {iconName && <Icon data-testid="icon" name={iconName} size="md" className={styles.icon} />}
    {children}
  </NewWindowAnchor>
);
